import { Module } from 'owa-workloads';
import updateModule from '../actions/updateModule';
import getStore from '../store/store';

export default function initializeModule(newModule: Module) {
    if (!getStore().module) {
        updateModule(newModule);
    }
}
